var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__backdrop"},[_c('div',{staticClass:"loader__content"},[_c('div',{staticClass:"loader__spinner"}),(_vm.message)?_c('div',{staticClass:"loader__message"},[_vm._v(_vm._s(_vm.$t(_vm.message)))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }